import { render, staticRenderFns } from "./DbStats.vue?vue&type=template&id=90d922a4&scoped=true"
import script from "./DbStats.vue?vue&type=script&lang=js"
export * from "./DbStats.vue?vue&type=script&lang=js"
import style0 from "./DbStats.vue?vue&type=style&index=0&id=90d922a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d922a4",
  null
  
)

export default component.exports